var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSerach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4407 16.4406C16.7411 16.1402 17.2281 16.1402 17.5285 16.4406L21.7747 20.6868C22.0751 20.9872 22.0751 21.4743 21.7747 21.7747C21.4743 22.0751 20.9873 22.0751 20.6869 21.7747L16.4407 17.5284C16.1403 17.228 16.1403 16.741 16.4407 16.4406Z",
    fill: "#848588"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.077 3.53846C6.91357 3.53846 3.53844 6.91364 3.53844 11.0771C3.53844 15.2406 6.91357 18.6158 11.077 18.6158C15.2404 18.6158 18.6156 15.2406 18.6156 11.0771C18.6156 6.91364 15.2404 3.53846 11.077 3.53846ZM2 11.0771C2 6.06397 6.06391 2 11.077 2C16.0901 2 20.154 6.06397 20.154 11.0771C20.154 16.0903 16.0901 20.1543 11.077 20.1543C6.06391 20.1543 2 16.0903 2 11.0771Z",
    fill: "#848588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerach);
export default __webpack_public_path__ + "static/media/serach.83ca26689fa27ac40713be968b9676d0.svg";
export { ForwardRef as ReactComponent };